export function isNumberHaveValue(number?: number | null): number is number {
  return typeof number === 'number'
}

export function isEmptyValue(value: any): boolean {
  return value === null || value === undefined || value === ''
}

export function randomNumber(): number {
  const crypto = window.crypto || (window as any).msCrypto
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  return array[0] / (0xffffffff + 1)
}

/**
 * Parses an integer in base 10. `Number.parseInt` defaults the radix from the
 * input's prefix, so an unguarded call reads "0x10" as 16 — pinning the radix
 * here keeps that surprise out of every call site.
 */
export function toInt(value: any): number {
  return Number.parseInt(value, 10)
}
